module.exports = __webpack_public_path__ + "img/download-dent-red.53c40d6c.svg";